import { render, staticRenderFns } from "./PopupArrow.vue?vue&type=template&id=76bc9af3&scoped=true"
import script from "./PopupArrow.vue?vue&type=script&lang=js"
export * from "./PopupArrow.vue?vue&type=script&lang=js"
import style0 from "./PopupArrow.vue?vue&type=style&index=0&id=76bc9af3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc9af3",
  null
  
)

export default component.exports